import { VerifyOTP } from "../../domain/useages/verify-otp";
import { HttpConstants } from "../protocols/http/http-constants";
import { HttpGetClient } from "../protocols/http/http-get-client";
import { HttpPostClient } from "../protocols/http/http-post-client";

export class RemoteVerifyOTP implements VerifyOTP {
  constructor(
    private readonly url: string,
    private readonly httpPostClient: HttpPostClient
  ) {}

  async verify(params: VerifyOTP.Params): Promise<any> {
    const httpResponse = await this.httpPostClient.post({
      url: this.url,
      body: params,
      headers: {
        [HttpConstants.CONTENT_TYPE]: HttpConstants.APPLICATION_JSON,
        [HttpConstants.ACCEPT]: HttpConstants.APPLICATION_JSON,
      },
      authHeaders: true,
    });
    // if (httpResponse.status === 200) {
    return httpResponse.data;
    // }
  }
}
